export const FUNCTIONALITY_TYPE = 'functionality';
export const PERFORMANCE_TYPE = 'performance';
